export default __webpack_public_path__ + "static/media/Pillow.af5eb65e.svg";